var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 3.33268C8.66683 2.9645 8.36836 2.66602 8.00016 2.66602C7.63196 2.66602 7.3335 2.9645 7.3335 3.33268C7.3335 3.70087 7.63196 3.99935 8.00016 3.99935C8.36836 3.99935 8.66683 3.70087 8.66683 3.33268Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 8.00065C8.66683 7.63245 8.36836 7.33398 8.00016 7.33398C7.63196 7.33398 7.3335 7.63245 7.3335 8.00065C7.3335 8.36885 7.63196 8.66732 8.00016 8.66732C8.36836 8.66732 8.66683 8.36885 8.66683 8.00065Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 12.6667C8.66683 12.2985 8.36836 12 8.00016 12C7.63196 12 7.3335 12.2985 7.3335 12.6667C7.3335 13.0349 7.63196 13.3333 8.00016 13.3333C8.36836 13.3333 8.66683 13.0349 8.66683 12.6667Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8a66a45a564e947bc9f557b492d9ad95.svg";
export { ForwardRef as ReactComponent };